export default __webpack_public_path__ + "static/media/lightning.9b4e295b.svg";